import wx from 'weixin-js-sdk';
import { Toast } from 'vant';
import $api from '@/request/api'; // 导入api接口
import $router from '../../router'; // 导入router
// 判断当前是否是微信浏览器
export function getIsWxClient() {
  const ua = navigator.userAgent.toLowerCase();
  const isWeixin = ua.indexOf('micromessenger') !== -1;
  if (isWeixin) {
    return true;
  }
  return false;
}
function checkInvoice(data) {
  Toast.loading({
    message: '加载中...',
    clear: true,
    forbidClick: true,
    loadingType: 'spinner',
  });
  $api.PublicPage.checkAmount({ invoice: data }).then((res) => {
    console.log(res, '==res');
    if (res.code === '200' && res.success) {
      $router.push({
        path: '/supermarket/v2/upoladSuccess',
        query: {
          type: 1,
          time: Date.parse(new Date()),
          data: JSON.stringify(res.data),
        },
      });
    } else {
      $router.push({
        path: '/supermarket/v2/upoladFail',
        query: {
          type: 1,
        },
      });
    }
  }).finally(() => {
    Toast.clear();
  });
}
// 注入微信配置信息
export function wxConfig() {
  if (getIsWxClient()) {
    Toast.loading({
      message: '加载中...',
      clear: true,
      forbidClick: true,
      loadingType: 'spinner',
    });
    const url = 'supermarket/v2/uploadTicket';
    // 调用接口获取微信配置
    $api.PublicPage.getWXConfig({
      requestUrl: decodeURIComponent(url),
    }).then((response) => {
      console.log(response, '==response');
      const {
        appId, timestamp, nonceStr, signature,
      } = response.data;

      // 使用JS-SDK的页面必须先注入配置信息
      window.wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来
        appId,
        timestamp,
        nonceStr,
        signature,
        jsApiList: ['scanQRCode'],
      });
    }).finally(() => {
      Toast.clear();
    });
  }
}


// 扫一扫
export function scanCode() {
  if (getIsWxClient()) {
    // checkJsApi 校验是否支持扫码
    window.wx.checkJsApi({
      jsApiList: ['scanQRCode'],
      success: (data) => {
        // scanQRCode 调用扫码
        window.wx.scanQRCode({
          desc: 'scanQRCode desc',
          needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
          success(res) {
            const scanVal = res.resultStr;
            console.log(scanVal, '==scanVal');
            let codeArr = [];
            if (scanVal.indexOf(',') !== -1) {
              codeArr = scanVal.split(',');
            }

            if (scanVal.indexOf('，') !== -1) {
              codeArr = scanVal.split(',');
            }
            if (codeArr.length === 0) return Toast('四要素不齐全，请扫描正确的发票二维码');

            if (codeArr.length <= 5) {
              return Toast('四要素不齐全，请扫描正确的发票二维码');
            }
            const billingDateVal = `${codeArr[5].substr(0, 4)}-${codeArr[5].substr(4, 2)}-${codeArr[5].substr(6, 2)}`;
            const codeList = codeArr[2];
            const invoiceNumVal = codeArr[3];
            const CheckCodeVal = codeArr[6].substr(codeArr[6].length - 6);
            const totalAmountVal = codeArr[4];
            console.log(billingDateVal, '==billingDateVal');
            // 时间不存在
            if (billingDateVal === '--') {
              return Toast('该发票不支持扫一扫，请通过手工录入，上传发票');
            }

            const dateTime = new Date().getFullYear(); /* 获取现在的年份 */
            const year5 = new Date(new Date().setFullYear(dateTime - 5)); // 五年后
            const stamp = Date.parse(year5); // 五年后的时间戳
            const newStamp = Date.parse(new Date(billingDateVal)); // 扫码的时间戳
            console.log(stamp, newStamp);
            if (stamp > newStamp) {
              return Toast('仅支持五年内的发票上传');
            }

            const params = {
              invoiceCode: codeList,
              invoiceNumber: invoiceNumVal,
              billingDate: billingDateVal,
              totalAmount: totalAmountVal || '',
              checkCode: CheckCodeVal || '',
            };
            checkInvoice(params);
          },
        });
      },
    });
  } else {
    Toast('仅支持在微信中扫一扫');
  }
}


// 继续上传
export const continueUpload = function (type) {
  // 扫一扫
  if (type == '1') {
    scanCode();
  }
  // 手工录入
  if (type == '2') {
    $router.push({
      path: '/supermarket/v2/manualEntry',
      query: { type: 2 },
    });
  }
};

function checkType(str) {
  if (str == '01' || str == '02' || str == '03' || str == '15' || str == '08') {
    // 显示金额字段
    return true;
  }
  // 显示校验码
  return false;
};

/** * 判断票种[国家税务总局全国增值税发票查验平台解密过来的方法alxd]
 * 其中名称里带“专票”字样的，查验需要输入不含税金额；其他查验需要输入检验码后六位。
 * @param a 需要监测的发票代码
 * @return c 票种代码
 * { "01","专票" },
 * { "02","货运专票" },
 * { "03","机动车专票" },
 * { "04","普票" },
 * { "10","电子票" },
 * { "08","电子票" },
 * { "11","卷票" },
 * { "14", "通信费"},
 * { "15", "二手车" },
 * { "99","其他" }
 ** */
export function checkInvoceType(fbdm) {
  const a = fbdm;
  const code = ['144031539110', '131001570151', '133011501118', '111001571071'];
  let b;
  let c = '99';
  if (a.length == 12) {
    b = a.substring(7, 8);
    for (let i = 0; i < code.length; i++) {
      if (a == code[i]) {
        c = '10';
        break;
      }
    }
    if (c == '99') {
      if (a.charAt(0) == '0' && a.substring(10, 12) == '11') {
        c = '10';
      }
      if (
        a.charAt(0) == '0'
        && (a.substring(10, 12) == '04' || a.substring(10, 12) == '05')
      ) {
        c = '04';
      }
      if (
        a.charAt(0) == '0'
        && (a.substring(10, 12) == '06' || a.substring(10, 12) == '07')
      ) {
        c = '11';
      }
      if (a.charAt(0) == '0' && a.substring(10, 12) == '12') {
        c = '14';
      }
      if (a.substring(10, 12) == '17' && a.charAt(0) == '0') {
        c = '15';
      }
      if (c == '99' && b == 2 && a.charAt(0) != '0') {
        c = '03';
      }
      // 添加电子专用发票的规则判断  20200308
      if (c == '99') {
        if (a.charAt(0) == '0' && a.substring(10, 12) == '13') {
          c = '08';
        }
      }
    }
  } else if (a.length == 10) {
    b = a.substring(7, 8);
    if (b == 1 || b == 5) {
      c = '01';
    } else if (b == 6 || b == 3) {
      c = '04';
    } else if (b == 7 || b == 2) {
      c = '02';
    }
  }
  return checkType(c);
}

